import { ResponsiveBar } from '@nivo/bar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CycleBucket } from '../../types/metrics';

interface FulfillmentCycleChartProps {
  data: CycleBucket[];
}

const FulfillmentCycleChart: React.FC<FulfillmentCycleChartProps> = ({
  data,
}) => {
  const { t } = useTranslation('app');

  const keys = ['under24', 'between24And48', 'between48And72', 'over72'];
  const colors = ['#4ade80', '#facc15', '#fb923c', '#f87171'];

  return (
    <div className="bg-app-panel-dark h-[400px] rounded-lg p-4">
      <h3 className="mb-4 text-lg font-semibold text-white">
        {t('Fulfillment Cycle Times')}
      </h3>
      <ResponsiveBar
        data={data}
        keys={keys}
        indexBy="groupKey"
        margin={{ top: 20, right: 130, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={colors}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: -45,
          legend: t('Date'),
          legendPosition: 'middle',
          legendOffset: 40,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: t('Percentage'),
          legendPosition: 'middle',
          legendOffset: -40,
          format: value => `${value}%`,
        }}
        enableLabel={false}
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 20,
            itemTextColor: 'rgba(255, 255, 255, 0.9)',
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1,
                },
              },
            ],
            data: [
              {
                id: 'under24',
                label: t('Under 24h'),
                color: colors[0],
              },
              {
                id: 'between24And48',
                label: t('24-48h'),
                color: colors[1],
              },
              {
                id: 'between48And72',
                label: t('48-72h'),
                color: colors[2],
              },
              {
                id: 'over72',
                label: t('Over 72h'),
                color: colors[3],
              },
            ],
          },
        ]}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: 'rgba(255, 255, 255, 0.5)',
              },
            },
            legend: {
              text: {
                fill: 'rgba(255, 255, 255, 0.9)',
              },
            },
          },
          grid: {
            line: {
              stroke: 'rgba(162, 188, 204, 0.15)',
            },
          },
          legends: {
            text: {
              fill: 'rgba(255, 255, 255, 0.9)',
            },
          },
        }}
        animate={true}
      />
    </div>
  );
};

export default FulfillmentCycleChart;
